import http from '@/http'

const URL = '/admin/forms'
const URL_FIELD_TYPES = '/admin/field-types'

// Forms
export const listForms = async (params) => {
  const list = await http.get(URL, { params })
  return list
}

export const getForm = async (id) => {
  if (id) {
    return http.get(`${URL}/${id}`)
  }
  return null
}

export const getFormBuilder = async (id) => {
  if (id) {
    return http.get(`${URL}/${id}/builder`)
  }
  return null
}

export const createForm = (payload) => {
  return http.post(`${URL}/builder`, payload)
}

export const saveFormComplete = (id, payload) => {
  return http.put(`${URL}/${id}/complete`, payload)
}

export const changeStatus = (id) => {
  return http.patch(`${URL}/${id}/status`)
}

export const deleteForm = async (id) => {
  return http.delete(`${URL}/${id}`)
}

export const duplicateForm = async (id) => {
  return http.post(`${URL}/${id}/duplicate`)
}

export const previewForm = async (id) => {
  return http.get(`${URL}/${id}/preview`)
}

// Steps
export const getSteps = async (formId) => {
  return http.get(`${URL}/${formId}/steps`)
}

export const createStep = async (formId, payload) => {
  return http.post(`${URL}/${formId}/steps`, payload)
}

export const updateStep = async (formId, stepId, payload) => {
  return http.put(`${URL}/${formId}/steps/${stepId}`, payload)
}

export const deleteStep = async (formId, stepId) => {
  return http.delete(`${URL}/${formId}/steps/${stepId}`)
}

export const reorderSteps = async (formId, payload) => {
  return http.patch(`${URL}/${formId}/steps/reorder`, payload)
}

// Fields
export const getFields = async (formId) => {
  return http.get(`${URL}/${formId}/fields`)
}

export const createField = async (formId, payload) => {
  return http.post(`${URL}/${formId}/fields`, payload)
}

export const updateField = async (formId, fieldId, payload) => {
  return http.put(`${URL}/${formId}/fields/${fieldId}`, payload)
}

export const deleteField = async (formId, fieldId) => {
  return http.delete(`${URL}/${formId}/fields/${fieldId}`)
}

export const reorderFields = async (formId, payload) => {
  return http.patch(`${URL}/${formId}/fields/reorder`, payload)
}

export const duplicateField = async (formId, fieldId) => {
  return http.post(`${URL}/${formId}/fields/${fieldId}/duplicate`)
}

// Field Types
export const getFieldTypes = async () => {
  const response = await http.get(URL_FIELD_TYPES, { params: { all: true, status: true } })
  return response.data
}

export const getFieldTypesGrouped = async () => {
  const response = await http.get(`${URL_FIELD_TYPES}/grouped`)
  return response.data
}

// ========================================
// FIELD TEMPLATES (Biblioteca de Campos Pré-prontos)
// ========================================
const URL_FIELD_TEMPLATES = '/admin/field-templates'

export const listFieldTemplates = async (params) => {
  const response = await http.get(URL_FIELD_TEMPLATES, { params })
  return response.data
}

export const getFieldTemplate = async (id) => {
  const response = await http.get(`${URL_FIELD_TEMPLATES}/${id}`)
  return response.data
}

export const createFieldTemplate = async (payload) => {
  const response = await http.post(URL_FIELD_TEMPLATES, payload)
  return response.data
}

export const updateFieldTemplate = async (id, payload) => {
  const response = await http.put(`${URL_FIELD_TEMPLATES}/${id}`, payload)
  return response.data
}

export const deleteFieldTemplate = async (id) => {
  const response = await http.delete(`${URL_FIELD_TEMPLATES}/${id}`)
  return response.data
}

export const getFieldTemplatesGrouped = async () => {
  const response = await http.get(`${URL_FIELD_TEMPLATES}/grouped`)
  return response.data
}

export const getFieldTemplateGroups = async () => {
  const response = await http.get(`${URL_FIELD_TEMPLATES}/groups`)
  return response.data
}

// ========================================
// FIELD TEMPLATE GROUPS (Grupos de campos pré-prontos)
// ========================================
const URL_TEMPLATE_GROUPS = '/admin/field-template-groups'

export const listTemplateGroups = async () => {
  const response = await http.get(URL_TEMPLATE_GROUPS)
  return response.data
}

export const createTemplateGroup = async (payload) => {
  const response = await http.post(URL_TEMPLATE_GROUPS, payload)
  return response.data
}

export const updateTemplateGroup = async (id, payload) => {
  const response = await http.put(`${URL_TEMPLATE_GROUPS}/${id}`, payload)
  return response.data
}

export const deleteTemplateGroup = async (id) => {
  const response = await http.delete(`${URL_TEMPLATE_GROUPS}/${id}`)
  return response.data
}

export const reorderGroupTemplates = async (id, payload) => {
  const response = await http.patch(`${URL_TEMPLATE_GROUPS}/${id}/reorder`, payload)
  return response.data
}

// ========================================
// FIELD TEMPLATE CATEGORIES (Categorias dos campos pré-prontos)
// ========================================
const URL_TEMPLATE_CATEGORIES = '/admin/field-template-categories'

export const listTemplateCategories = async () => {
  const response = await http.get(URL_TEMPLATE_CATEGORIES)
  return response.data
}

export const createTemplateCategory = async (payload) => {
  const response = await http.post(URL_TEMPLATE_CATEGORIES, payload)
  return response.data
}

export const updateTemplateCategory = async (id, payload) => {
  const response = await http.put(`${URL_TEMPLATE_CATEGORIES}/${id}`, payload)
  return response.data
}

export const deleteTemplateCategory = async (id) => {
  const response = await http.delete(`${URL_TEMPLATE_CATEGORIES}/${id}`)
  return response.data
}

// ========================================
// REGISTRATION CONTROL FIELDS (Campos do Controle de Inscrição)
// ========================================
const URL_REGISTRATION_CONTROLS = '/admin/registration-controls'

export const getRegistrationControlFields = async (controlId) => {
  const response = await http.get(`${URL_REGISTRATION_CONTROLS}/${controlId}/form-builder-fields`)
  return response.data
}

// Tags efetivamente usadas em itens do Controle de Inscrição. Usado pelo
// FieldEditor para só exibir o controle "Exibir campo apenas para tags X"
// quando há ao menos um item com tag. Retorna [] se nenhum item tem tag.
export const getRegistrationControlItemTags = async () => {
  const response = await http.get(`${URL_REGISTRATION_CONTROLS}/item-tags`)
  return response.data
}

export default {
  listForms,
  getForm,
  getFormBuilder,
  createForm,
  saveFormComplete,
  changeStatus,
  deleteForm,
  duplicateForm,
  previewForm,
  getSteps,
  createStep,
  updateStep,
  deleteStep,
  reorderSteps,
  getFields,
  createField,
  updateField,
  deleteField,
  reorderFields,
  duplicateField,
  getFieldTypes,
  getFieldTypesGrouped,
  // Field Templates
  listFieldTemplates,
  getFieldTemplate,
  createFieldTemplate,
  updateFieldTemplate,
  deleteFieldTemplate,
  getFieldTemplatesGrouped,
  getFieldTemplateGroups,
  // Template Groups
  listTemplateGroups,
  createTemplateGroup,
  updateTemplateGroup,
  deleteTemplateGroup,
  reorderGroupTemplates,
  // Template Categories
  listTemplateCategories,
  createTemplateCategory,
  updateTemplateCategory,
  deleteTemplateCategory,
  // Registration Control Fields
  getRegistrationControlFields,
  getRegistrationControlItemTags
}
